import { useCallback, useEffect, useState } from 'react';
import {
  conectEventSource,
  getOrderData,
  listenerErrorEventSource,
  listenerEventSource,
  listenerOpenEventSource,
  removeListenerEventSource,
} from './apiCalls';
import PersonalPayButton from './components/PersonalPayButton';
import { DatasetProps, FType, ResponseEvent, ResponseFetchOrder, APIVersions } from './types/types';
import { buildDeeplink, checkDataset, isIOS, switchApiVersion } from './utils/utils';
import { isBrowser } from 'react-device-detect';
import { useGlobalState } from './state/GlobalProvider';
import {
   BLOCKED_APP_CHANNELS,
   CSS_URL } from './constants/constants';

const App = () => {
  const { state, setState } = useGlobalState();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [errGenerateOrder, _setErrGenerateOrder] = useState<boolean>(false)
  const [apiVersion, setApiVersion] = useState<APIVersions>('1');
  const [startConnection, setStartConnection] = useState<boolean>(false)
  const [renderBtn, setRenderBtn] = useState<boolean>(false)
  const checkOutElementDataset = document.getElementById('checkout-pay')?.dataset! as DatasetProps
  const callbackFunction = window[checkOutElementDataset?.callbackFunction as keyof typeof window] || ''
  const flowType: FType = isBrowser ? 'desktop' : 'mobile'

  const { orderData, eventSourceGlobal, getOrderLoading } = state;

  useEffect(() => {
    var head = document.head;
    const style = document.createElement('link');
    style.rel = 'stylesheet';
    style.type = 'text/css';
    style.href = CSS_URL;
    style.onload = () => setRenderBtn(true);
    head.appendChild(style);
  }, []);

  const handleClickPersonalPayBtn = (): void => {
    getData();
  };

  useEffect(() => {
    if (orderData) {
      setStartConnection(true);
      const isBlockedChannel = BLOCKED_APP_CHANNELS.includes(
        checkOutElementDataset.sellerChannel,
      );
        // si es desktop, o no es ios y NO está en la lista de BLOCKED_APP_CHANNELS utiliza el urlFlowRedirect 
        if(flowType === 'desktop' || (!isIOS && !isBlockedChannel)){
          window.location.assign(orderData.data.urlFlowRedirect)
          return
        }
        // en caso que sea mobile y está en la lista redirige a la web con todos los parametros en el deeplink 
        // y va a la pantalla intermedia donde utiliza el urlFlowRedirect con hashid
      const url = buildDeeplink(checkOutElementDataset, orderData!);
      window.location.assign(url);
    }
  }, [checkOutElementDataset, flowType, orderData]);

  const getData = useCallback(async () => {
    try {
      setState((prev) => ({ ...prev, getOrderLoading: true }))
      const orderData = await getOrderData(checkOutElementDataset, flowType, apiVersion)
      setState((prev) => ({ ...prev, getOrderLoading: false, orderData: orderData as ResponseFetchOrder }))
      callbackFunction && callbackFunction({ status: 200, msg: 'Order created' })
      // setErrGenerateOrder(false)
    } catch (error: any) {
      setState((prev) => ({ ...prev, getOrderLoading: false }))
      console.error('Order error:', error?.message || error, error?.cause)
      callbackFunction && callbackFunction({ 
        status: 400, 
        msg: 'The order could not be created',
        cause: error?.cause
      })      
      // setErrGenerateOrder(true)
    }
  }, [setState, checkOutElementDataset, flowType, callbackFunction, apiVersion])

  useEffect(() => {
    if (checkOutElementDataset && checkDataset(checkOutElementDataset)) {      
      switchApiVersion(checkOutElementDataset, setApiVersion)
    }
  }, [checkOutElementDataset]);

  const onResponse = useCallback(
    (e: MessageEvent) => {
      const data: ResponseEvent = JSON.parse(e.data);
      const { status } = data.clientAdditionalData;
      callbackFunction && callbackFunction({ status: 202, msg: status });
    },
    [callbackFunction],
  );

  const onOpen = useCallback(
    (e: Event) => {
      callbackFunction &&
        callbackFunction({ status: 201, msg: 'Open connection' });
    },
    [callbackFunction],
  );

  const onError = useCallback(
    (e: Event) => {
      callbackFunction &&
        callbackFunction({ status: 401, msg: 'Error connection' });
    },
    [callbackFunction],
  );

  useEffect(() => {
    if (startConnection) {
      if (!eventSourceGlobal) {
        const eventSource = conectEventSource(
          'statusOrder',
          orderData?.data?.orderId,
        );
        setState((prev) => ({ ...prev, eventSourceGlobal: eventSource }));
      } else {
        listenerEventSource(eventSourceGlobal, onResponse);
        listenerOpenEventSource(eventSourceGlobal, onOpen);
        listenerErrorEventSource(eventSourceGlobal, onError);
      }
    }

    return () => removeListenerEventSource(eventSourceGlobal!);
  }, [
    startConnection,
    onResponse,
    onOpen,
    onError,
    orderData,
    setState,
    eventSourceGlobal,
  ]);

  return (
    <>
      {renderBtn ? (
        <PersonalPayButton
          {...{
            handleClickPersonalPayBtn,
            errGenerateOrder,
            isLoading: getOrderLoading,
          }}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default App;
